var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgGoogleCalendar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.79 14.21H14.21v31.58h31.58V14.21Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.79 60 60 45.79H45.79V60Z",
    fill: "#EA4335"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14.21H45.79v31.58H60V14.21Z",
    fill: "#FBBC04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.79 45.79H14.21V60h31.58V45.79Z",
    fill: "#34A853"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 45.79v9.473A4.736 4.736 0 0 0 4.737 60h9.473V45.79H0Z",
    fill: "#188038"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60 14.21V4.737A4.736 4.736 0 0 0 55.263 0H45.79v14.21H60Z",
    fill: "#1967D2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.79 0H4.736A4.736 4.736 0 0 0 0 4.737v41.052h14.21V14.21h31.58V0Z",
    fill: "#4285F4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.688 38.708c-1.18-.797-1.997-1.962-2.443-3.501l2.74-1.13c.248.948.682 1.682 1.302 2.203.616.521 1.366.778 2.242.778.896 0 1.666-.273 2.309-.817.643-.545.967-1.24.967-2.08 0-.861-.34-1.564-1.018-2.108-.68-.545-1.532-.817-2.55-.817h-1.583v-2.712h1.42c.877 0 1.615-.237 2.215-.71.6-.474.9-1.122.9-1.947 0-.734-.268-1.318-.805-1.757-.537-.438-1.216-.659-2.04-.659-.806 0-1.445.213-1.92.644a3.775 3.775 0 0 0-1.033 1.583l-2.712-1.13c.36-1.018 1.018-1.918 1.985-2.695.967-.778 2.203-1.169 3.703-1.169 1.11 0 2.108.213 2.992.644.884.43 1.579 1.026 2.08 1.784.502.762.75 1.614.75 2.562 0 .967-.233 1.784-.698 2.455a4.815 4.815 0 0 1-1.717 1.543v.162a5.215 5.215 0 0 1 2.202 1.717c.573.77.86 1.69.86 2.764 0 1.073-.272 2.032-.816 2.873-.545.84-1.3 1.504-2.254 1.986-.96.481-2.037.726-3.233.726-1.386.004-2.665-.395-3.845-1.192Zm16.828-13.595-3.008 2.175-1.504-2.281 5.396-3.893h2.068v18.36h-2.952v-14.36Z",
    fill: "#4285F4"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgGoogleCalendar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/google-calendar.ca8be185a77f48b59be52f00ce2ea433.svg";